import { useEffect } from 'react';

const useTitle = (value) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${value} - Union Square`;
    return () => {
      document.title = prevTitle;
    };
  });
};

export default useTitle;
